import React, {useState} from 'react';
import {Menu} from "antd";
import {useAuth0} from "../../services/auth0";
import {Link} from "react-router-dom";
import {UserOutlined} from '@ant-design/icons';
import {Profile} from "../Profile/Profile";
import {roles} from "../../constants";

const {SubMenu} = Menu;

const SignedInLinks = ({role}) => {
    const [modalState, setModalState] = useState(false);
    const {logout} = useAuth0();
    const returnLink = window.location.origin;
    const logoutObj = {returnTo: returnLink};

    const userLogOut = () => {
        localStorage.clear();
        logout(logoutObj);
    };

    const profileModalHandler = (state) => {
        setModalState(state);
    }

    return (
        <React.Fragment>
            <Menu mode="horizontal">
                <Menu.Item key="1"><Link
                    to={role && role === roles.ADMIN || role === roles.TRANSLATOR ? '/user-requests' : '/dashboard'}>Dashboard</Link></Menu.Item>
                <Menu.Item key="2">
                    <a type="link" target="_blank" href="mailto:contact@paradi.io">Contact Us</a>
                </Menu.Item>
                <SubMenu title={<span className="submenu-title-wrapper">
                    <UserOutlined/></span>}>
                    {(role === roles.ADMIN || role === roles.USER) && <Menu.Item key="3"><Link to="/payment">Plans</Link></Menu.Item>}
                    {role === roles.USER && <Menu.Item key="4" onClick={() => profileModalHandler(true)}>Profile</Menu.Item>}
                    <Menu.Item key="5" onClick={userLogOut}>Logout</Menu.Item>
                </SubMenu>
            </Menu>
            {modalState && (<Profile toggleModal={profileModalHandler} visible={modalState}/>)}
        </React.Fragment>
    )
};

export default SignedInLinks;
